export const sketch = (p5) => {
    let capture;
    let arImage;
    let imgLoaded;
    let imgLoading = false;
    let takePicture = false;
    let showCaptureButton = true;
    let buttonSize = 70;

    p5.setup = () => {
        let canvas = p5.createCanvas(p5.windowWidth, p5.windowHeight);
        canvas.parent("ARFallbackCanvas");
        capture = p5.createCapture({
            audio: false,
            video: {
                facingMode: 'environment',
            },
        });
    };

    p5.stop = () => {
        capture.remove();
    };

    p5.draw = () => {
        p5.background(0, 0, 0);
        let finalHeight, finalWidth;
        let imgRatio = capture.height / capture.width;
        let canvasRatio = p5.height / p5.width;

        if (canvasRatio > imgRatio) {
            finalHeight = p5.height;
            let scale = finalHeight / capture.height;
            finalWidth = Math.round(capture.width * scale, 0);
        } else {
            finalWidth = p5.width;
            let scale = finalWidth / capture.width;
            finalHeight = Math.round(capture.height * scale, 0);
        }

        p5.image(
            capture,
            (p5.width - finalWidth) / 2,
            (p5.height - finalHeight) / 2,
            finalWidth,
            finalHeight
        );

        if (p5.customURL && !imgLoaded && !imgLoading) {
            imgLoading = true;
            p5.loadImage(p5.customURL, (img) => {
                arImage = img;
                imgLoaded = true;
            });
        }

        if (imgLoaded) {
            let imgRatio = arImage.height / arImage.width;
            let canvasRatio = p5.height / p5.width;

            if (canvasRatio > imgRatio) {
                let finalWidth = p5.width;
                let scale = finalWidth / arImage.width;
                let finalHeight = Math.round(arImage.height * scale, 0);
                let y = (p5.height - finalHeight) / 2;
                p5.image(arImage, 0, y, finalWidth, finalHeight);
            } else {
                let finalHeight = p5.height;
                let scale = finalHeight / arImage.height;
                let finalWidth = Math.round(arImage.width * scale, 0);
                let x = (p5.width - finalWidth) / 2;
                p5.image(arImage, x, 0, finalWidth, finalHeight);
            }
        }

        if (showCaptureButton) {
            p5.strokeWeight(5);
            p5.stroke("#fffffd");
            p5.fill("#dbdce0");
            p5.ellipse(p5.width / 2, p5.height - buttonSize, buttonSize, buttonSize);
        }
    };
};
